import { useContext } from 'react';
import { UNSAFE_RouteContext as RouteContext, useMatches } from 'react-router-dom';

// The id of the route rendered by this route's <Outlet />: the v7 counterpart of a v5 guard's own `path`.
// RouteContext holds the matches up to and including the calling route, so its length indexes the child.
export const useChildRouteId = () => {
  const { matches } = useContext(RouteContext);

  return useMatches()[matches.length]?.id;
};
